import React from 'react';
import nl2br from 'react-nl2br'
import Linkify from 'react-linkify'
import ErrorMessage from './ErrorMessage'

import '../../styles/messages/TextMessage.css'

var re_url = new RegExp(/(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/gi);

export default class TextMessage extends React.PureComponent {
    constructor() {
        super();
        this.onTextBoxClick = this.onTextBoxClick.bind(this);
    }

    render() {
        try {
            var {content} = this.props.message
            content = content.replace(re_url, function (url) {
                return ' ' + url + ' '
            })
            var isFlag = content.indexOf('qlchat') === -1 && content.indexOf('qianliao') === -1 && content.indexOf('xiaoe') === -1

            return (
                <div className="text-content " onClick={this.onTextBoxClick}>
                    <p className="wrap-text">
                        {isFlag ?
                            <Linkify properties={{target: "_blank"}}>{nl2br(content)}</Linkify>
                            :
                            <span>{nl2br(content)}</span>
                        }
                    </p>
                </div>
            )
        } catch(e) {
            return <ErrorMessage/>
        }
    }

    onTextBoxClick() {
        let {message} = this.props;
        let operatePPT = message.ppt;
        if (operatePPT) {
            // 如果绑定了ppt，则切换对应的ppt
            this.props.dispatch({
                type: "CLASSROOM_SET_SELECTED_PPT",
                payload: operatePPT
            });
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/messages/TextMessage.js